import { createFileRoute } from '@tanstack/react-router'
import { requireAdmin } from '@/lib/auth-guards'
import { AdminAttentionPage } from '@/features/trainer-attention/admin-attention-page'

export const Route = createFileRoute(
  '/_authenticated/check-ins/trainer-attention'
)({
  beforeLoad: requireAdmin,
  component: AdminAttentionPage,
})
